import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.to-string.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "view-container"
};
var _hoisted_2 = {
  class: "title-container"
};
var _hoisted_3 = {
  class: "text"
};
var _hoisted_4 = {
  key: 0
};
var _hoisted_5 = {
  class: "view-header"
};
var _hoisted_6 = {
  class: "update-time"
};
var _hoisted_7 = {
  class: "search-box"
};
var _hoisted_8 = {
  key: 0,
  class: "select-item"
};
var _hoisted_9 = {
  key: 1,
  class: "select-item"
};
var _hoisted_10 = {
  class: "view-content"
};
var _hoisted_11 = {
  class: "view-card-item"
};
var _hoisted_12 = {
  class: "label"
};
var _hoisted_13 = {
  class: "value"
};
var _hoisted_14 = {
  class: "view-card-item"
};
var _hoisted_15 = {
  class: "label"
};
var _hoisted_16 = {
  class: "value"
};
var _hoisted_17 = {
  class: "view-card-item"
};
var _hoisted_18 = {
  class: "label"
};
var _hoisted_19 = {
  class: "value"
};
var _hoisted_20 = {
  class: "view-card-item"
};
var _hoisted_21 = {
  class: "label"
};
var _hoisted_22 = {
  class: "value"
};
import { skipUrl as skipUrlOpen } from '@/util/util';
import { appAliasEvent } from '@/utils/auth.js';
import { HelpCircleIcon } from 'tdesign-icons-vue-next';
import { reactive, ref, computed, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { getRectorWeekStatic, getClass, getDeptAuthList } from '@/api/home.js';
import useUserStore from '@/stores/modules/user.js';
import { getStore } from '@/util/store.js';
import dayjs from 'dayjs';
export default {
  __name: 'teacherDataView',
  props: {
    role: {
      type: String,
      default: ''
    },
    schoolList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup(__props) {
    var _storeToRefs = storeToRefs(useUserStore()),
      dataViewSchoolId = _storeToRefs.dataViewSchoolId;
    var _useUserStore = useUserStore(),
      setDataViewSchoolId = _useUserStore.setDataViewSchoolId;
    var userInfo = getStore({
      name: 'userInfo'
    });
    var schoolState = reactive({
      show: false,
      value: '',
      name: '',
      options: []
    });
    var directorState = reactive({
      show: false,
      value: 2,
      name: '一年级',
      options: [{
        label: '一年级',
        value: 1
      }, {
        label: '二年级',
        value: 2
      }, {
        label: '三年级',
        value: 3
      }]
    });
    var classTypeOptions = ref([{
      label: '行政班',
      value: 3
    }, {
      label: '教学班',
      value: 4
    }]);
    var classOptions = ref([]);
    var classType = ref(3);
    var classRoom = ref('');
    var staticData = reactive({
      studentNum: '',
      // 学生数
      classRoomNum: '',
      // 班级数
      classTimeNum: '',
      // 课次数
      courseRate: '',
      // 电子学程使用率
      studentRate: '',
      // 学生展示参与率
      updateTime: '',
      // 数据更新时间
      dateFormat: '' //汇总
    }); // 统计数据

    /* 学生数量和班级数量 */
    var valueNum = computed(function () {
      var isTeacher = props.role === 'teacher';
      var value = isTeacher ? staticData.studentNum : staticData.classRoomNum;
      return value ? value : '0';
    });
    var onConfirmSchool = function onConfirmSchool(value) {
      setDataViewSchoolId(value);
    };
    var onConfirmDirector = function onConfirmDirector(value) {
      getInfo({
        grade: value
      });
    };
    var props = __props;
    var openApp = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(item) {
        var appUrl;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return appAliasEvent(item);
            case 1:
              appUrl = _context.v;
              if (appUrl) {
                skipUrlOpen(appUrl);
              }
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function openApp(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var getGradeList = function getGradeList(schoolId) {
      var userId = userInfo.id;
      var gradeParam = {
        deptId: schoolId,
        userId: userId,
        type: 1
      };
      getDeptAuthList(gradeParam).then(function (res) {
        var _list$, _list$2, _list$3;
        var list = res.data.data.map(function (v) {
          return {
            label: v.name,
            value: v.id
          };
        });
        console.log(list);
        directorState.options = list;
        directorState.name = (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$['name'];
        directorState.value = (_list$2 = list[0]) === null || _list$2 === void 0 ? void 0 : _list$2['value'];
        console.log(directorState);
        getInfo({
          grade: (_list$3 = list[0]) === null || _list$3 === void 0 ? void 0 : _list$3['value']
        });
      });
    };
    var getClassOptions = function getClassOptions() {
      var userId = userInfo.id;
      getClass({
        userId: userId,
        classType: classType.value
      }).then(function (res) {
        var list = res.data.data;
        classOptions.value = list.map(function (v) {
          return {
            label: v.name,
            value: v.value
          };
        });
        classRoom.value = list[0] ? list[0]['value'] : '';
        handleChange();
      });
    };
    var handleChange = function handleChange() {
      getInfo({
        classType: classType.value,
        classRoom: classRoom.value
      });
    };
    var getInfo = function getInfo(_ref2) {
      var _ref2$grade = _ref2.grade,
        grade = _ref2$grade === void 0 ? '' : _ref2$grade,
        _ref2$classType = _ref2.classType,
        classType = _ref2$classType === void 0 ? '' : _ref2$classType,
        _ref2$classRoom = _ref2.classRoom,
        classRoom = _ref2$classRoom === void 0 ? '' : _ref2$classRoom;
      var method = {
        rector: {
          fn: getRectorWeekStatic,
          parmas: {
            schoolId: schoolState.value
          }
        },
        director: {
          fn: getRectorWeekStatic,
          parmas: {
            schoolId: dataViewSchoolId.value,
            grade: grade
          }
        },
        teacher: {
          fn: getRectorWeekStatic,
          parmas: {
            classType: classType,
            classRoom: classRoom
          }
        }
      };
      method[props.role]['fn'](method[props.role]['parmas'], props.role).then(function (res) {
        var _ref3 = res.data.data || {},
          studentNum = _ref3.studentNum,
          classRoomNum = _ref3.classRoomNum,
          classTimeNum = _ref3.classTimeNum,
          courseRate = _ref3.courseRate,
          studentRate = _ref3.studentRate,
          updateTime = _ref3.updateTime,
          dateFormat = _ref3.dateFormat;
        staticData.studentNum = studentNum || '';
        staticData.classRoomNum = classRoomNum || '';
        staticData.classTimeNum = classTimeNum || '';
        staticData.courseRate = courseRate || '';
        staticData.studentRate = studentRate || '';
        staticData.dateFormat = dateFormat || '';
        staticData.updateTime = dayjs(updateTime).format('MM-DD HH:mm');
      });
    };
    watch(function () {
      return props.schoolList;
    }, function (val) {
      schoolState.options = val.map(function (v) {
        return {
          label: v.schoolName,
          value: v.schoolId
        };
      });
      if (val && val.length) {
        schoolState.value = val[0].schoolId;
      } else {
        schoolState.value = '';
      }
      getInfo({});
    }, {
      immediate: true
    });
    watch(function () {
      return dataViewSchoolId.value;
    }, function (val) {
      if (props.role === 'rector' && val) {
        getInfo({});
      } else if (props.role === 'director' && val) {
        getGradeList(val);
      }
    });
    watch(function () {
      return props.role;
    }, function (val) {
      if (val === 'rector') {
        console.log('校长');
      } else if (val === 'director') {
        console.log('获取年级列表');
      } else if (val === 'teacher') {
        console.log('获取班级');
        // 获取班级信息
        getClassOptions();
      }
    }, {
      immediate: true
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_option = _resolveComponent("t-option");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_tooltip = _resolveComponent("t-tooltip");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        name: "common-icon",
        size: "24",
        class: "icon"
      }), _createElementVNode("span", _hoisted_3, [_createTextVNode(_toDisplayString(__props.role === 'teacher' ? '月课堂' : '周课堂'), 1), staticData.dateFormat ? (_openBlock(), _createElementBlock("span", _hoisted_4, "（" + _toDisplayString(staticData.dateFormat) + "）", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, "更新时间  " + _toDisplayString(staticData.updateTime), 1), _createElementVNode("div", _hoisted_7, [__props.role === 'rector' && schoolState.options.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_component_t_select, {
        modelValue: schoolState.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return schoolState.value = $event;
        }),
        class: "select-warp",
        style: {
          "width": "160px"
        },
        placeholder: "选择学校",
        onChange: onConfirmSchool
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schoolState.options, function (item, index) {
            return _openBlock(), _createBlock(_component_t_option, {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), __props.role === 'director' && directorState.options.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_t_select, {
        modelValue: directorState.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return directorState.value = $event;
        }),
        class: "select-warp",
        style: {
          "width": "90px"
        },
        placeholder: "请选择年级",
        onChange: onConfirmDirector
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(directorState.options, function (item, index) {
            return _openBlock(), _createBlock(_component_t_option, {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])])) : _createCommentVNode("", true), __props.role === 'teacher' ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 2
      }, [_createVNode(_component_t_select, {
        modelValue: classType.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return classType.value = $event;
        }),
        class: "select-warp",
        style: {
          "width": "90px"
        },
        placeholder: "班级类型",
        onChange: getClassOptions
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classTypeOptions.value, function (item, index) {
            return _openBlock(), _createBlock(_component_t_option, {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_t_select, {
        modelValue: classRoom.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return classRoom.value = $event;
        }),
        class: "select-warp",
        style: {
          "width": "130px",
          "margin-left": "8px"
        },
        placeholder: "请选择班级",
        onChange: handleChange
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(classOptions.value, function (item, index) {
            return _openBlock(), _createBlock(_component_t_option, {
              key: index,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue"])], 64)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
        class: "view-card-list",
        onClick: _cache[4] || (_cache[4] = function ($event) {
          return openApp('dataView');
        })
      }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createTextVNode(_toDisplayString(__props.role === 'teacher' ? '学生数' : '班级数') + " ", 1), _createVNode(_component_t_tooltip, {
        placement: "top",
        content: __props.role === 'teacher' ? '使用课堂互动平台授课内学生的总和' : '使用课堂互动平台授课的班级，按周去重统计'
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "label-tip",
            size: "16px"
          })];
        }),
        _: 1
      }, 8, ["content"])]), _createElementVNode("div", _hoisted_13, _toDisplayString(valueNum.value), 1)]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_cache[5] || (_cache[5] = _createTextVNode(" 电子学程使用 ", -1)), _createVNode(_component_t_tooltip, {
        placement: "top",
        content: "课堂有打开电子学程的课次数/使用平台授课的课次数"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "label-tip",
            size: "16px"
          })];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_16, _toDisplayString(staticData.courseRate || '0%') + _toDisplayString(staticData.courseRate && '%'), 1)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_cache[6] || (_cache[6] = _createTextVNode(" 课次数 ", -1)), _createVNode(_component_t_tooltip, {
        placement: "top",
        content: "使用课堂互动平台授课的课次数，按周去重统计"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "label-tip",
            size: "16px"
          })];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_19, _toDisplayString(staticData.classTimeNum || '0'), 1)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, [_createTextVNode(_toDisplayString(__props.role === 'teacher' ? '展示参与率' : '学生参与率') + " ", 1), _createVNode(_component_t_tooltip, {
        placement: "top",
        content: "AVG(参与展示学生人数/应到班级人数)"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_unref(HelpCircleIcon), {
            class: "label-tip",
            size: "16px"
          })];
        }),
        _: 1
      })]), _createElementVNode("div", _hoisted_22, _toDisplayString(staticData.studentRate || '0%') + _toDisplayString(staticData.studentRate && '%'), 1)])])])]);
    };
  }
};